class SlickMediaGalleryProduct extends HTMLElement {
  constructor() {
    super();

    this.slideshow = this.querySelector('.slideshow');
    this.photoSlides = this.slideshow.querySelectorAll('.photo-slide');

    this.slickGalleryHolder = this.querySelector('.slick-media-gallery-holder-inner');
    this.slickGalleryNav = this.querySelector('.slick-navigation');
    this.loadingSquare = this.querySelector('.loading-square');

    var w = document.documentElement.clientWidth;
    var h = document.documentElement.clientHeight;

    if(w >= 768){
      this.photoSlides.forEach(photo => {
        var photo_url = photo.dataset.photo;
        $(photo).zoom({
          url: photo_url,
          magnify: 1.5
        });
      });
    }

    this.initSlideshowSlick();

    this.navClick = this.querySelectorAll('.slide-nav-button')
    this.navClick.forEach(item => {
      item.addEventListener('click', this.navItemClick.bind(this));
    });
  }

  navItemClick(){

    this.navClick.forEach(item => {
      item.classList.remove('border')
    });

    event.target.closest('.slide-nav-button').classList.add('border')

    var slideNumber = event.target.closest('.slide-nav-button').dataset.slideNum;
    $(this.slideshow).slick('slickGoTo', (parseInt(slideNumber) - 1));
  }

  highlightNavItem(item_num){
    this.navClick.forEach(item => {
      item.classList.remove('border')
    });

    this.navClick[item_num].classList.add('border');
  }

  initSlideshowSlick(){

    var arrows_enable = this.dataset.arrows == 'true' ? true : false;

    var slick_options = {
      dots: this.dataset.dots == 'true' ? true : false,
      arrows: arrows_enable,
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      autoplaySpeed: parseInt(this.dataset.autoplaySpeed),
      draggable: this.dataset.draggable == 'true' ? true : false,
      speed: parseInt(this.dataset.speed),
      infinite: this.dataset.infinite == 'true' ? true : false,
      fade: this.dataset.fade == 'true' ? true : false,
      slidesToShow: parseInt(this.dataset.slidesToShow),
      slidesToScroll: parseInt(this.dataset.slidesToScroll),
      centerMode: this.dataset.centerMode == 'true' ? true : false,
      accessibility: this.dataset.accessibility == 'true' ? true : false,
      adaptiveHeight: this.dataset.adaptiveHeight == 'true' ? true : false,
      cssEase: this.dataset.easing,
      useTransform: this.dataset.useTransform == 'true' ? true : false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: parseInt(this.dataset.slidesToShowLarge),
            slidesToScroll: parseInt(this.dataset.slidesToScrollLarge)
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: parseInt(this.dataset.slidesToShowTablets),
            slidesToScroll: parseInt(this.dataset.slidesToScrollTablets)
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: parseInt(this.dataset.slidesToShowSmall),
            slidesToScroll: parseInt(this.dataset.slidesToScrollSmall)
          }
        }
      ]
    };

    if(this.querySelector('.slideshow-prev')){
      slick_options['prevArrow'] = this.querySelector('.slideshow-prev')
    }
    if(this.querySelector('.slideshow-next')){
      slick_options['nextArrow'] = this.querySelector('.slideshow-next')
    }

    this.loadingSquare.remove();

    this.slickGalleryHolder.classList.remove('hidden');
    this.slickGalleryNav.classList.remove('hidden');
    $(this.slideshow).slick(slick_options);

    $(this.slideshow).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      this.highlightNavItem(nextSlide)
    });

  }
}

customElements.define('slick-media-gallery-product', SlickMediaGalleryProduct);
